// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_s4X","cls2":"ReferenceEvaluationPage-cls2_4rz ReferenceEvaluationPage-cls1_s4X"};